import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';

const PAN_ENDPOINT = {
  verifyPan: 'search/verify-pan',
  ngoSearch: 'search/ngo-search',
  getPreviousReport: 'previous-reports'
}

@Injectable({
  providedIn: 'root'
})
export class PanService {

  constructor(private apiService: ApiService) { }

  verifyPan(pan: string, latestRecord: boolean = false): Observable<any> {
    const params = {
      pan,
      ...(latestRecord && { latestRecord: true })
    };
    return this.apiService.get(PAN_ENDPOINT.verifyPan, { params });
  }

  ngoSearch(reportOverviewState: any): Observable<any> {
    return this.apiService.post(PAN_ENDPOINT.ngoSearch, reportOverviewState);
  }

  getPreviousReport(txnId: string): Observable<any> {
    return this.apiService.get(PAN_ENDPOINT.getPreviousReport + '/' + txnId);
  }
}
